class CollectionTabs extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      buttons: '[button-tab-cta]',
      products: '[tab-product-block]',
      viewAll: '[button-view-all]',
    }
    this.init();
  }
  init() {
    this.buttons = this.querySelectorAll(this.selectors.buttons);
    this.products = this.querySelectorAll(this.selectors.products);
    this.viewAll = this.querySelector(this.selectors.viewAll);
    this.buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        this.buttons.forEach(prevBtn => {
          if (prevBtn.classList.contains('active')) {
            prevBtn.classList.remove('active');
          }
        });
        if (!btn.classList.contains('active')) {
          btn.classList.add('active');
          this.toggleProducts(btn);
        }
      });
    });
  }
  toggleProducts(button) {
    this.products.forEach(ele => {
      if (ele.classList.contains('active')) {
        ele.classList.remove('active');
      }
    });
    const productsDiv = this.querySelector(`[tab-product-block][data-id="${button.dataset.id}"]`);
    console.log(productsDiv);
    if (productsDiv && !productsDiv.classList.contains('active')) {
      productsDiv.classList.add('active');
      this.viewAll.href = productsDiv.dataset.url;
    }
  }
}
customElements.define('collection-tabs', CollectionTabs);